import { render, staticRenderFns } from "./LinkExpensesTable.vue?vue&type=template&id=45b5a09d&scoped=true"
import script from "./LinkExpensesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkExpensesTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinkExpensesTable.vue?vue&type=style&index=0&id=45b5a09d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b5a09d",
  null
  
)

export default component.exports